import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { StandardSiteNavigationFragment } from '../../../graphql-types';
import { WLHeader } from '../../design-library';
import { NavData } from '../../design-library/Header/types';
import LinksArrayAdapter from '../LinksArrayAdapter';

const StandardHeaderAdapter = () => {
  const result = useStaticQuery<StandardSiteNavigationFragment>(graphql`
    query {
      ...StandardSiteNavigation
    }
  `);

  const parsedData = React.useMemo(() => {
    if (result?.contentfulSiteData?.navigation?.internal?.content) {
      return JSON.parse(
        result?.contentfulSiteData.navigation.internal.content,
      ) as NavData;
    }
    return null;
  }, [result?.contentfulSiteData?.navigation?.internal?.content]);

  const notifications = React.useMemo(() => {
    const notificationData =
      result?.contentfulSiteData?.notifications?.internal?.content;
    try {
      // An empty list of notifications comes through as a non-empty JSON string from the CMS
      // We have to parse it here to decide whether to build the adapter component.
      // If we don't do this we can't easily decide whether to hide the notification bar
      // since there's an empty wrapper element
      const parsedNotifications = JSON.parse(notificationData || '{}');
      if ((parsedNotifications?.['data']?.length ?? 0) === 0) {
        return undefined;
      }
    } catch {
      return undefined;
    }
    return notificationData
      ? [
          <LinksArrayAdapter
            json={notificationData}
            isHeader
            key="cms-notifications"
          />,
        ]
      : undefined;
  }, [result?.contentfulSiteData?.notifications?.internal?.content]);

  if (!parsedData) {
    return null;
  }

  return <WLHeader navData={parsedData} notifications={notifications} />;
};

export default StandardHeaderAdapter;
